// extracted by mini-css-extract-plugin
export default {"subcategory-container":"SubcategorySection_subcategory-container__-H9FK"};